export function translateCategories(categories: string[], t:any) : string[] {
    return categories.map((category) => t(`solutions.categories.${category}`));
}